app.service('paymentOperator', function (orderConfig, modal) {
	var $agreement, $self, config;

	var checkTerm = {
		PLATNOSCI: false,
		TPAY: false,
		P24: false
	}


	function init() {
		$self = $('#permissions');
		$agreement = $('#payment-agreement', $self);
		config = orderConfig.getData();

		$agreement.on('click', function () {
			saveTermSelected();
		});
		setRegulationUrl(config.paymentOperator, config.regulationUrl);
		saveTermSelected();
	}
	function setValidate(ignore) {
		$agreement.ignore(ignore);
	}

	function saveTermSelected() {
		if (config.paymentOperator && config.paymentOperator.length) {
			checkTerm[config.paymentOperator] = $agreement.is(':checked');
		}
	}
	function setRegulationUrl(operator, regulationUrl) {
		var $div = '';
		if (regulationUrl) {
			if (operator == 'PLATNOSCI') {
				$div = $('#payu-regulation a');
				$('#payu-regulation a').attr('href', regulationUrl);
			} else if (operator == 'TPAY') {
				$('#tpay-regulation a').attr('href', regulationUrl);
			} else if (operator == 'P24') {
				$('#p24-regulation a').attr('href', regulationUrl);
			}
			if ($div.length) {
				$div.attr('href', regulationUrl);
			}
		}
	}
	function change(operator, regulationUrl) {
		if ($self && $self.length) {
			if (typeof operator === "string" && typeof regulationUrl === "string") {
				var currentOperator = '' + config.operator;
				config.paymentOperator = operator;
				if (operator.length == 0) {
					console.log('Brak operatora');
					setValidate(true);
					$self.removeClass("tpay payu p24");
				} else if (currentOperator == operator) {
					console.log(`Ten sam operator: ${operator}`);
				} else {
					console.log(`Zmiana operatora z '${currentOperator}' na ${operator}`);
					setValidate(false);
					$self.removeClass("tpay payu p24");
					if (operator == 'PLATNOSCI') {
						$self.addClass("payu");
					} else if (operator == 'TPAY') {
						$self.addClass("tpay");
					} else if (operator == 'P24') {
						$self.addClass("p24");
					}
					setRegulationUrl(operator, regulationUrl);
					if (operator.length) {
						$agreement.prop('checked', checkTerm[operator]);
					}
				}
			} else {
				modal.alert('Błąd zapisywania danych płatności. Spróbuj ponownie')
			}
		}
	}

	return {
		init, change, setRegulationUrl
	};
});
